import { connect } from 'react-redux';

import { ICookiePolicyState } from '@store/types';
import { openCookieSettings } from '@store/actions';

import CookiePolicy, {
  ICookiePolicyStateProps,
  ICookiePolicyDispatchProps,
} from '../components/policies/CookiePolicy';

const mapStateToProps = ({
  cookiePolicy,
}: {
  cookiePolicy: ICookiePolicyState;
}): ICookiePolicyStateProps => ({
  html: cookiePolicy.html,
});

const mapDispatchToProps = (): ICookiePolicyDispatchProps => ({
  openCookieSettings: openCookieSettings,
});

export default connect(mapStateToProps, mapDispatchToProps)(CookiePolicy);
